const config = {
  apiGateway: {
    URL: "https://vdjxl4u1eh.execute-api.ca-central-1.amazonaws.com/v1/",
    AUTH: "https://0mi2m4ye61.execute-api.ca-central-1.amazonaws.com/v1/",
    REGION: "ca-central-1"
  },
  defaultLanguage: "en",
  sso_enabled: true,
  sso_config: {
            auth_url: "msc-prod.auth.ca-central-1.amazoncognito.com",
            identity_provider: "MSC-PROD-AD",
            scope: "openid+aws.cognito.signin.user.admin",
            grant_type: "authorization_code",
            client_id: "5pqqmkfp1ctguq1cmjg8a8ggm4",
            redirect_uri: "https://mswc.digitalsolved.ca/authorize",
        },
  dast_config: {enabled: false},
  canadaPostApiKey: "KT28-NK89-WZ24-WP93",
  fef_ui_version: "2.0.64.2-tier2"
}

var siteConfig = {
  title: "Morgan Stanley Wealth Canada",
  fourlyticsId: false,
  fourlyticsScreenRecording: false
};

var componentConfig = {
  
};

export {config, siteConfig, componentConfig}
